import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const ListSelectUserPermissionsStyle = styled.div`
  width: 100%;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  .input-label {
    text-align: start;
  }
  .input {
    display: flex;
    flex-direction: row;

    .select-element-wrapper {
      width: 90%;
    }

    .delete-button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 10%;
      svg {
        fill: black;
        height: 15px;
        width: 15px;
      }
    }
  }

  .input-container {
    margin-top: 10px;
    width: 48%;
    margin-bottom: 0;
  }

  .title-permissions {
    width: 100%;
    text-align: start;
    margin-top: 10px;
    font-size: 14px;
    margin-bottom: 20px;
    ${fontFamily.sourceSansPro.bold};
  }

  .permissions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    /* margin-top: 10px; */

    .option-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 16px;

      .text-permission {
        font-size: 14px;
      }

      .check-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-right: 16px;

        .box {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 28px;
          width: 28px;
          background-color: white;
          border-radius: 6px;
          svg {
            fill: ${colors.limeGreen};
            width: 20px;
            height: 15px;
          }
        }
      }
    }
  }

  .add-new-institution {
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${colors.softBlue};

    .text {
      margin-left: 17px;
    }

    .plus-container {
      display: flex;
      justify-content: center;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 2px solid ${colors.softBlue};
      svg {
        fill: ${colors.softBlue};
        height: 10px;
        width: 10px;
        align-self: center;
        justify-self: center;
      }
    }
  }
`;
